<template>
  <div class="login-page-wrapper">
    <div class="w-full max-w-login mx-auto px-6 animate__animated animate__fadeIn">
      <div class="flex flex-col md:flex-row items-center">

        <!-- Sección izquierda: branding + acciones -->
        <div class="w-full md:w-1/2 py-12 md:py-0 px-2">
          <div class="flex items-center">
            <CrystalLogo :size="50" />
            <span
              class="font-semibold"
              style="font-size: 42px; line-height: 42px; color: #0288D1; font-family: 'Quicksand', sans-serif; letter-spacing: 0.5px"
            >CRYSTAL</span>
          </div>

          <p
            class="font-semibold mt-3"
            :style="descriptionStyle"
          >Tu equipo, organizado y bajo control</p>

          <p class="mt-2" style="font-size: 16px; line-height: 24px; color: #6b7280; max-width: 380px">
            La plataforma integral de recursos humanos para empresas que crecen.
          </p>

          <section class="flex flex-col items-start gap-3 mt-4">
            <AccessButton />
            <wz-button variant="outline" size="xl" @click="$router.push('/')">Ir a documentación</wz-button>
          </section>

          <p class="mt-4" style="font-size: 13px; color: #6b7280">
            Forjado por
            <a
              href="http://wize.pe/"
              target="_blank"
              rel="noopener"
              class="font-medium hover:underline"
              style="color: var(--admin-primary-color, #0288D1); text-decoration: none"
            >Wize</a>
            © {{ year }}
          </p>
        </div>

        <!-- Sección derecha: imagen estática -->
        <div class="w-full md:w-1/2 pb-12 md:pb-0 px-2">
          <div class="text-center">
            <img
              src="@/core/assets/images/login/banner.png"
              alt="Crystal"
              class="w-full h-auto mx-auto"
              style="max-width: 520px"
            />
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { SecurityService } from "@/core/services";
import { Alert } from "@wizepe/wizeui"
import { ErrorUtils } from "@wizepe/wizeui"
import { SSOUtils } from "@wizepe/wizeui"
import AccessButton from "../Components/AccessButton";
import { defineAbilitiesFor } from '@/core/plugins/abilities';
import CrystalLogo from '@/core/components/icons/CrystalLogo.vue';

export default {
  name: "LoginPage",
  components: {
    AccessButton,
    CrystalLogo,
  },
  provide() {
    return {
      $ability: { from: "test" }
    }
  },
  data() {
    return {
      error: false,
      errorMsg: null,
      year: new Date().getFullYear(),
      descriptionStyle: {
        fontSize: '42px',
        lineHeight: '48px',
        maxWidth: '400px',
        color: 'rgb(62, 70, 87)',
        fontFamily: "'Quicksand', sans-serif",
      },
    };
  },
  methods: {
    async loginSso() {
      this.errorMsg = null;
      this.loading = true;
      this.$store.commit('app/setLoading', true)
      const callbackParams = SSOUtils.getCallbackParameters(location.href);
      if (this.$store.getters["auth/getSsoState"] === callbackParams.state) {
        this.$store.commit("auth/ssoState", null);
        try {
          const response = await SecurityService.loginSSO(callbackParams);
          if (response.status !== "OK") {
            return (this.errorMsg = ErrorUtils.getErrorMessages(response));
          }
          await this.$store.dispatch("auth/setTokens", response.payload);
          const userResponse = await SecurityService.getUserInfo();
          await this.$store.dispatch("auth/setUser", userResponse.payload);
          defineAbilitiesFor(userResponse.payload.roles);
          await this.$router.push({ name: "dashboard" });
        } catch (ex) {
          Alert.error(ex.errors.message);
          await this.$router.push({ name: "login" });
          console.error(ex);
        } finally {
          this.$store.commit('app/setLoading', false)
        }
      } else {
        this.$store.commit('app/setLoading', false)
        Alert.error("Hubo un error al autenticar al usuario, por favor intenta nuevamente");
      }
    },
  },
  mounted() {
    if (window.location.search) this.loginSso();
  },
};
</script>

<style scoped>
.login-page-wrapper {
  min-height: 100vh !important;
  display: flex !important;
  align-items: center !important;
  box-sizing: border-box;
  padding: 0 !important;
  margin: 0 !important;
}
</style>
